module.exports = __webpack_public_path__ + "img/decathlon-canada.edc341a1.png";